/**
 *  Format JS date into WF format
 *
 * @param {string|integer} timestamp date that is to be formatted
 * @param {boolean} isSmallDevice current device is mobile or desktop, default is desktop
 * @return {string} the formatted date string, MM/DD/YY for Desktop and MM/YY for mobile
 */
export const getFormattedDate = (timestamp, isSmallDevice = false) => {
	const d = new Date(timestamp);
	if (isSmallDevice)
		return (
			d.getMonth() +
			1 +
			"/" +
			d
				.getFullYear()
				.toString()
				.substr(2)
		);
	return (
		d.getMonth() +
		1 +
		"/" +
		d.getDate() +
		"/" +
		d
			.getFullYear()
			.toString()
			.substr(2)
	);
};

/**
 * Format JS date into UTC YYYY-MM-DD HH:MM:SS string, for use in data aggregation.
 * @param {string|integer} timestamp date that is to be formatted
 * @return {string} the UTC date string in YYYY-MM-DD HH:MM:SS format
 */
export const getDataFormattedUTCDate = (timestamp) => {
	const x = new Date(timestamp);

	const d = [
		x.getUTCFullYear(),
		x.getUTCMonth() + 1,
		x.getUTCDate(),
		x.getUTCHours(),
		x.getUTCMinutes(),
		x.getUTCSeconds(),
	];
	d.forEach((a, i) => {
		let b = a.toString();
		d[i] = b.length > 1 ? b : `0${b}`;
	});

	return `${d[0]}-${d[1]}-${d[2]} ${d[3]}:${d[4]}:${d[5]}`;
};
